import React from "react";

// Outline stopwatch; takes its colour from the surrounding text (currentColor).
export const StopwatchIcon = ({ size = 22, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <line x1="10" y1="2" x2="14" y2="2" />
      <line x1="12" y1="2" x2="12" y2="5" />
      <line x1="19" y1="6" x2="20.5" y2="4.5" />
      <circle cx="12" cy="14" r="8" />
      <polyline points="12 10 12 14 15 16" />
    </svg>
  );
};
